import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["loader", "iframe"]

    connect() {
        console.log("🎬 Video Loader connected")
        if (this.hasIframeTarget) {
            // Check if iframe is already loaded (can happen with Turbo)
            if (this.iframeTarget.complete || this.isIframeLoaded(this.iframeTarget)) {
                this.hideLoader()
            } else {
                // Standard load event
                this.iframeTarget.addEventListener('load', () => this.hideLoader())
            }
        }
    }

    isIframeLoaded(iframe) {
        try {
            return iframe.contentDocument && iframe.contentDocument.readyState === 'complete'
        } catch (e) {
            // Cross-origin will throw error, which usually means it loaded something
            return true
        }
    }

    hideLoader() {
        console.log("✅ Video loaded, hiding loader")
        if (this.hasLoaderTarget) {
            this.loaderTarget.classList.add('opacity-0')
            setTimeout(() => {
                this.loaderTarget.classList.add('hidden')
            }, 300)
        }
        if (this.hasIframeTarget) {
            this.iframeTarget.classList.remove('opacity-0')
        }
    }
}
